export default __webpack_public_path__ + "static/media/type-notification.7057f673.svg";